export enum Spec {
  AllTabDisabled = 'specs.siteSearch.AllTabDisabled',
  AppControllerLayoutFix = 'specs.siteSearch.AppControllerLayoutFix',
  NewResultsPerPageDefaultValue = 'specs.siteSearch.NewResultsPerPageDefaultValue',
  ProGallery = 'specs.siteSearch.ProGallery',
  UseWarmupData = 'specs.siteSearch.UseWarmupData',
  MobileSettings = 'specs.siteSearch.MobileSettings',
  DisableAllTabByDefault = 'specs.siteSearch.DisableAllTabByDefault',
}
